export const PASS = 'PASS_BUTTON/PASS';
export const PASS_DONE = 'PASS_BUTTON/PASS_DONE';